import { render, staticRenderFns } from "./document-analysis.vue?vue&type=template&id=9489b1d4&"
import script from "./document-analysis.vue?vue&type=script&lang=js&"
export * from "./document-analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports